let isInferenceMockEnabled = false;

/** Re-applied on every init, so a re-init without the flags turns the mocks back off. */
const apply = ({useMockData}: {useMockData?: boolean}) => {
    isInferenceMockEnabled = useMockData === true;
};

const isInferenceEnabled = () => isInferenceMockEnabled;

export default {apply, isInferenceEnabled};
